import React from 'react';
import AppLayout from './layout/AppLayout';
import TasksWidget from './dashboard/TasksWidget';
import CalendarWidget from './dashboard/CalendarWidget';
import MessagesWidget from './dashboard/MessagesWidget';
import DocumentsWidget from './dashboard/DocumentsWidget';
import NotificationsWidget from './dashboard/NotificationsWidget';
import TeamWidget from './dashboard/TeamWidget';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export default function DashboardPage() {
  useDocumentTitle('Dashboard');
  
  return (
    <AppLayout>
      <div className="p-6">
        <div className="max-w-7xl mx-auto">
          {/* Grid Layout */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Priority Widgets - Full Width */}
            <div className="md:col-span-2 lg:col-span-3">
              <TasksWidget />
            </div>

            {/* Medium Widgets */}
            <div className="lg:col-span-2">
              <CalendarWidget />
            </div>
            <div>
              <NotificationsWidget />
            </div>

            {/* Regular Widgets */}
            <div>
              <MessagesWidget />
            </div>
            <div>
              <DocumentsWidget />
            </div>
            <div>
              <TeamWidget />
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}